export const LEGAL_LINKS_STATE_KEY = '__legalLinksState';
export const LEGAL_LINKS_SYNC_EVENT = 'legal-links:sync';

const DEFAULT_STATE = {
	vueLinks: {},
	orderedNames: [],
	numberByName: {}
};

export function getLegalLinksState() {
	if (!window[LEGAL_LINKS_STATE_KEY]) {
		window[LEGAL_LINKS_STATE_KEY] = { ...DEFAULT_STATE };
	}

	return window[LEGAL_LINKS_STATE_KEY];
}

export function getLegalByName(name) {
	if (!name) return null;

	const legals = window.legals || [];

	return legals.find((legal) => legal.name === name) || null;
}

export function getLegalLinkLabel(locale = window.Shopify?.locale || 'uk') {
	return locale === 'uk'
		? 'Примітка'
		: 'Примечание';
}

export function syncVueLegalLink(id, name) {
	if (!id) return;

	const state = getLegalLinksState();

	if (name) {
		state.vueLinks[id] = name;
	} else {
		delete state.vueLinks[id];
	}

	window.dispatchEvent(
		new CustomEvent(LEGAL_LINKS_SYNC_EVENT, {
			detail: { id, name }
		})
	);
}